import { AbstractReport } from '../abstract-report.model';
import { AccessorsMutatorsDecorator } from '../../../../helpers/model';

export class TaxReport extends AbstractReport {

}
AccessorsMutatorsDecorator(
    'id',
    'name',
    'amount',
    'mtd',
    'ytd',
    'amount_formatted',
    'mtd_formatted',
    'ytd_formatted',
    'type'
)(TaxReport);



// WEBPACK FOOTER //
// ./src/pms-api/models/reports/financial/tax-report.model.js